import React from 'react';

import { MODE_CARDS } from './table_layout';
import { useFitLayout, useOverflowReport } from './use_container_layout';

/*
 * A hand-built <table> that never scrolls sideways: when it is wider than its box its rows stack,
 * each cell under its data-label (teacher_payments.css .tp-stack). Cells must carry data-label.
 */
const FitTable = ({ className = '', children }) => {
  const { ref, mode, width, on_overflow } = useFitLayout({ threshold: 0 });
  const stacked = mode === MODE_CARDS;
  const fit_ref = useOverflowReport(width, (need) => {
    if (!stacked) on_overflow(mode, need);
  });
  return (
    <div ref={ref} className={`tp-tablewrap ${className}`.trim()} data-mode={mode}>
      <div ref={fit_ref} className={`tp-rt-fit${stacked ? ' tp-stack' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default FitTable;
